import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { defineAsyncComponent } from 'vue'

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        redirect: '/home' // 默认重定向到 /home
    },
    {   // 首页
        path: '/home',
				name: 'Home',
         component: ()=> import("@/page/home/index.vue"),
    },{
        // 产品或者解决方案页面
        path: '/products',
        name: 'Products',
        component: ()=> import("@/page/products/index.vue"),

    },{
        // 解决方案
        path: '/solution',
        name: 'Solution',
        component: ()=> import("@/page/solution/index.vue"),
    },{
        // 成功案例
        path: '/cases',
        name: 'Cases',
        component: ()=> import("@/page/cases/index.vue"),
    },{
        // 下载中心
        path: '/download',
        name: 'Download',
        
				component: ()=> import("@/page/download/index.vue"),
    },{
        // 关于外面
        path: '/about',
        name: 'About',
        component: ()=> import("@/page/about/index.vue"),
    },{
        // 试用
        path: '/trial',
        name: 'Trial',
        component: ()=> import("@/page/trial/index.vue"),
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
		scrollBehavior(to, from, savedPosition) {
			return { top: 0 };
		}
});
router.beforeEach((to, from, next) => {
  // 确保调用 next() 以继续路由跳转
	//next();
	next();
});
	
export default router;